import $ from "jquery";
import Vue from "vue";
import * as ers from "../../../errorsmessages/errors";
import * as suc from "../../../successmessages/success";
import * as rt from "../../../routes/routes";
import * as ses from "../../../configurations/session/sessioncomplete";
import baseurl from "../../../configurations/baseurl/baseurl";
import router from "../../../router/index";

export const actions = {
  newTrip({ state }) {
    let tripDetails = {
      consignee_id: $(".consignee_id").val(),
      truck_id: $(".truck_id").val(),
      loading_date: $(".loading_date").val(),
      container_no: $(".container_no").val(),
      container_expiry_date: $(".container_expiry_date").val(),
      from: $(".from").val(),
      to: $(".to").val(),
      grand_total: $(".grand_total").val(),
      trip_income: state.trip_income
    };
    $(".creatingTrip").hide();
    $(".creatingTripLoader").show();
    baseurl.post(rt.newTrip, tripDetails).then(res => {
      $(".creatingTrip").show();
      $(".creatingTripLoader").hide();

      if (res.data.code === 200) {
        suc.tripsCreateSuccess();
        router.push("/managetrips");
      } else if (res.data.code === 402) {
        ers.validateErrors();
      } else if (res.data.code === 403) {
        ers.tripExists();
      } else if (res.data.code === 404) {
        ers.errorCreatingTrips();
      } else if (res.data.code === 405) {
        ers.noPermissionToCreate();
        router.push("/dashboard");
      } else if (res.data.code === 506) {
        ses.sessionComplete();
      }
    });
  },

  loadTrips({ commit }) {
    baseurl.get(rt.loadTrips).then(res => {
      $(".tripsLoader").hide();

      if (res.data.code === 200) {
        commit("STORE_TRIPS", res.data.trips);
      } else if (res.data.code === 404) {
        ers.errorLoadingTrips();
      } else if (res.data.code === 405) {
        ers.noPermissionToRead();
        router.push("/dashboard");
      } else if (res.data.code === 506) {
        ses.sessionComplete();
      }
    });
  },

  viewTrip({ commit }, tripId) {
    commit("STORE_TRIP_UPDATE", tripId);
    router.push("/newexpenses");
  },
  viewTruckInterchange({ commit }, tripId) {
    commit("STORE_TRIP_UPDATE", tripId);
    router.push("/newinterchange");
  },

  loadPayments({ commit }, tripId) {
    commit("STORE_TRIP_UPDATE", tripId);
    baseurl.get(rt.loadPayments + tripId).then(res => {
      if (res.data.code === 200) {
        commit("STORE_PAYMENTS", res.data.payments);
        router.push("/payments");
      } else if (res.data.code === 404) {
        ers.errorLoadingPayments();
      } else if (res.data.code === 405) {
        ers.noPermissionToRead();
        router.push("/dashboard");
      } else if (res.data.code === 506) {
        ses.sessionComplete()
      }
    });
  }
};
export default actions;



// WEBPACK FOOTER //
// ./src/vuex/modules/trips/actions.js